export default "__VITE_ASSET__DH34D5kc__"